import type { TranslationMessages } from './types';

export const support: TranslationMessages = {
  title: 'Hỗ trợ',
  description:
    'Chúng tôi có thể giúp gì cho bạn? Hãy chọn một tùy chọn bên dưới.',
  reportBug: 'Báo cáo lỗi',
  viewFaq: 'Xem FAQ',
};
